'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeComment = exports.editComment = exports.createComment = exports.listComment = undefined;

var _actions = require('../utils/actions');

var listComment = exports.listComment = function listComment(contentId, query) {
  return {
    args: { contentId: contentId, query: query },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('listComment'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.get(_actions.apiPrefix + '/comment/' + userId + '/' + contentId, {
        q: query,
        resType: 'json'
      });
    }
  };
};

var createComment = exports.createComment = function createComment(contentId) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!data.text) {
    throw new Error('No comment input in createComment');
  }
  return {
    args: { contentId: contentId, data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('createComment'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.post(_actions.apiPrefix + '/comment/' + userId + '/' + contentId + '/create', {
        body: data,
        resType: 'json'
      });
    }
  };
};

var editComment = exports.editComment = function editComment(contentId, commentId, data) {
  if (!data.text) {
    throw new Error('No comment input in createComment');
  }
  return {
    args: { contentId: contentId, commentId: commentId, data: data },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('editComment'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.patch(_actions.apiPrefix + '/comment/' + userId + '/' + contentId + '/' + commentId, {
        body: data,
        resType: 'json'
      });
    }
  };
};

var removeComment = exports.removeComment = function removeComment(contentId, commentId) {
  return {
    args: { contentId: contentId, commentId: commentId },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('removeComment'),
    minselfAPICall: function minselfAPICall(client, userId) {
      return client.delete(_actions.apiPrefix + '/comment/' + userId + '/' + contentId + '/' + commentId, {
        resType: 'json'
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/comment.js
// module id = 505
// module chunks = 1